// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1fb3d","emails":"CreateEditClinics_emails__iQQDk","emailTagLabel":"CreateEditClinics_emailTagLabel__1c_Q5"};